import React from "react";
import { motion } from "framer-motion";
import { Award, Cpu, Factory, FlaskConical, Globe2, Workflow } from "lucide-react";
import { WHY_PILLARS } from "../../data/site";

const ICONS = [Award, Cpu, Factory, FlaskConical, Globe2, Workflow];

export const WhyWeldmatix = () => {
  return (
    <section data-testid="why-weldmatix" className="relative bg-[#F8FAFC] py-24 md:py-32 border-t border-[#E2E8F0] overflow-hidden">
      <div className="absolute -top-10 left-0 right-0 num-watermark text-center select-none">WHY</div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="eyebrow mb-4">// Why Weldmatix · 02</div>
            <h2 className="font-display uppercase tracking-tight text-slate-900 text-4xl md:text-6xl leading-[0.95]">
              Built by<br /><span className="text-[#0EA5E9]">engineers,</span><br />for engineers.
            </h2>
          </div>
          <div className="md:col-span-7 md:pl-10 flex items-end">
            <p className="text-base md:text-lg text-[#475569] leading-relaxed max-w-xl">
              Weldmatix is a vertically integrated welding-automation OEM. We engineer,
              fabricate, integrate and commission every system in-house — giving you a
              single point of accountability for performance, uptime and support.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {WHY_PILLARS.map((p, i) => {
            const Icon = ICONS[i] ?? Workflow;
            return (
              <motion.div
                key={p.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
                className="spec-card p-8 relative group"
                data-testid={`why-pillar-${p.n}`}
              >
                <div className="flex items-start justify-between mb-10">
                  <div className="w-12 h-12 border border-[#E2E8F0] flex items-center justify-center group-hover:border-[#0EA5E9] group-hover:text-[#0EA5E9] transition-colors text-slate-900">
                    <Icon className="w-5 h-5" strokeWidth={1.6} />
                  </div>
                  <span className="font-mono-wm text-xs tracking-[0.25em] text-[#64748B]">{p.n}</span>
                </div>
                <h3 className="font-display text-xl md:text-2xl uppercase text-slate-900 tracking-tight leading-tight">{p.t}</h3>
                <p className="mt-3 text-sm text-[#475569] leading-relaxed">{p.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyWeldmatix;
